<template>
    <div>
        <p><a @click="close" href="#">close</a></p>
    </div>
</template>

<script>
export default {
    props: ['phoneNumber'],

    methods: {
        close() {
            Bus.$emit('phone_numbersCancelShow', this.phoneNumber.id);
        }
    }
};
</script>
